import Validator from "js-object-validation";
import { message } from "../common";

export const addStaffValidator = (data) => {
  const validations = {
    name: {
      required: true,
      alpha: true,
    },
    email: {
      required: true,
      email: true,
    },

    role_id: {
      required: true,
    },
  };
  // Error messages
  const messages = {
    name: {
      required: message.Required.replace(":item", "name"),
      alpha: message.InvalidName.replace(":item", "name"),
    },
    email: {
      required: message.Required.replace(":item", "email"),
      email: message.InvalidEmail,
    },
    role_id: {
      required: message.Required.replace(":item", "role name"),
    },
    personal_email: {
      email: message.InvalidEmail,
    },
    phone: {
      numeric: message.InvalidPhone,
    },
    office_phone: {
      numeric: message.InvalidPhone,
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
